import { useFetchPaginatedData } from "@hooks/api/useFetchPaginatedData";
import { GetAllUsuarios } from "@services/Usuario/Index";

export function useFetchDataEncarregados() {
    // Usa o hook genérico para buscar todos os encarregados
    const { data, loading, fetchAllData } = useFetchPaginatedData(GetAllUsuarios, 50, { perfil: "ENCARREGADO"});

    return {
       encarregadosOptions: data.map((item) => ({
           value: item.id,
           label: item.nome,
       })).sort((a, b) => a.label.localeCompare(b.label)),
       encarregadoLoading: loading,
       fetchEncarregados: fetchAllData,
    };
}
